module.exports = __webpack_public_path__ + "assets/directions_run.129cb725.svg";